<div data-test="LJ-Hczta" (mdOutsideClick)="hideFilter()">
  <button
    *ngIf="!ngrxFormControl.value"
    data-test="78OLwB-S"
    class="icon icon_sm"
    (click)="showFilter()"
  >
    <svg data-test="FA5VBbcC" class="icon__icon-filter" width="10px" height="10px">
      <use xlink:href="#icon-filter"></use>
    </svg>
  </button>
  <div
    data-test="v2PozJ1D"
    class="dropdown dropdown_bottom-middle dropdown_arrow dropdown_search-tooltip"
    [ngClass]="{ 'show active': show }"
  >
    <div data-test="AbnQKCId" class="dropdown__wrap p-0">
      <input
        *ngIf="!number; else numberInput"
        data-text-input
        placeholder="Press Enter to apply filter"
        data-test="7cbXjbcI"
        class="input input_sm"
        style="text-align: center"
        [ngrxFormControlState]="ngrxFormControl"
        (keyup.enter)="emitSelected(); hideFilter()"
      />
      <ng-template #numberInput>
        <input
          data-number-input
          data-test="RtXSLskk"
          mdNumberInput
          [ngrxValueConverter]="numberConverter"
          placeholder="Press Enter to apply filter"
          class="input input_sm"
          style="text-align: center"
          [ngrxFormControlState]="ngrxFormControl"
          (keyup.enter)="emitSelected(); hideFilter()"
        />
      </ng-template>
    </div>
  </div>
  <span data-test="gJBKycOS" *ngIf="ngrxFormControl.value">
    <span
      data-test="Aloetcqz"
      class="cursor-pointer"
      (click)="showFilter()"
      style="text-transform: none"
    >
      ({{ ngrxFormControl.value }})
    </span>
    <i
      data-test="d6y4jHoo"
      class="material-icons md-12 cursor-pointer"
      (click)="onClearClick()"
    >
      close
    </i>
  </span>
</div>
